import { render, staticRenderFns } from "./BaseInputFilearea.vue?vue&type=template&id=64fbfae0&"
import script from "./BaseInputFilearea.vue?vue&type=script&lang=js&"
export * from "./BaseInputFilearea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports